import { createContext, ReactNode } from 'react';
import { Provider } from 'use-http';
import jwt_decode from "jwt-decode";

import { logOut } from './auth.helpers';
import { MARKETPLACE_GWT, MARKETPLACE_DEV_CONTEXT } from './constants';

export type TAPIDeveloperContext = {
  "status": string,
  "phone_number": string,
  "external_id": string,
  "updated_at": string | null,
  "email": string,
  "first_name": string,
  "company_name": string,
  "id": string,
  "created_at": string,
  "last_name": string,
  "status_change_date": string,
  "username": string
};

export type TAuthContext = {
  parsedToken: string | null | unknown,
  developerContext: TAPIDeveloperContext | null
};

export const AuthContext = createContext<TAuthContext>({ parsedToken: null, developerContext: null });

export const AuthWithContext = (props: { children: ReactNode }) => {
  const token = localStorage.getItem(MARKETPLACE_GWT);
  const developerContext = localStorage.getItem(MARKETPLACE_DEV_CONTEXT);
  const parsedToken = {
    parsedToken: token && jwt_decode(token || ''),
    developerContext: developerContext && JSON.parse(developerContext)
  };
  const options = {
    interceptors: {
      request: async ({ options }: any) => {
        if (token) {
          options.headers.Authorization = `Bearer ${token}`
        }
        return options
      },
      response: async ({ response }: any) => {
        if (response.status === 401) {
          logOut()
        }

        return response;
      }
    }
  }

  return (
    <Provider url={process.env.NX_API_URL} options={options}>
      <AuthContext.Provider value={parsedToken}>
        {props.children}
      </AuthContext.Provider>
    </Provider>
  );
}
